import React from 'react';
import ManualPayoutsPanel from '@/features/shared/components/ManualPayoutsPanel';
import { ysr2Mobile } from '@/features/shared/styles/mobileDesignSystem';

const MobilePayoutsPage = () => {
  return (
    <div className={`${ysr2Mobile.shell} h-[100dvh] flex flex-col`}>
      <div className={ysr2Mobile.orbBlue} />
      <div className={ysr2Mobile.orbPurple} />
      <div className="relative z-10 flex-1 overflow-y-auto px-4 pt-4 pb-28">
        <div className={`${ysr2Mobile.surfaceStrong} p-4 mb-4`}>
          <p className="text-xs uppercase tracking-[0.22em] text-blue-100/70">Artist finance</p>
          <h1 className="text-2xl font-black text-white">Payouts</h1>
          <p className="text-sm text-blue-100/70">Track earnings and request withdrawals</p>
        </div>
        <ManualPayoutsPanel compact={true} />
      </div>
    </div>
  );
};

export default MobilePayoutsPage;
